import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
    {
        num: "01",
        title: "Vistoria & mapa de pontos",
        text: "Visitamos o local e definimos onde cada câmera e cada leitor facial realmente fazem diferença.",
    },
    {
        num: "02",
        title: "Projeto & especificação",
        text: "Desenhamos o sistema completo: equipamentos, cabeamento, gravação e integração com a portaria.",
    },
    {
        num: "03",
        title: "Instalação limpa",
        text: "Fios embutidos, testes ponto a ponto e tudo configurado no seu celular antes de irmos embora.",
    },
    {
        num: "04",
        title: "Entrega & suporte",
        text: "Treinamento de quem vai usar, garantia registrada e manutenção periódica para nada falhar.",
    },
];

const Process = () => (
    <section id="processo" className="relative py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <Reveal className="mb-14">
                <Eyebrow>[ 03 — Processo ]</Eyebrow>
                <h2 className="mt-4 max-w-2xl font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05] text-white">
                    Um método técnico,
                    <span className="text-volt"> sem improviso.</span>
                </h2>
            </Reveal>

            <div
                data-testid="process-steps-timeline"
                className="grid sm:grid-cols-2 gap-5"
            >
                {STEPS.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.08}>
                        <div className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-panel p-8 hover:border-volt/40 transition-colors duration-300">
                            <span className="pointer-events-none absolute -top-3 right-4 font-display text-7xl font-black text-white/5 group-hover:text-volt/10 transition-colors duration-300">
                                {s.num}
                            </span>
                            <span className="font-hud text-[11px] tracking-[0.3em] text-volt">
                                {s.num}
                            </span>
                            <h3 className="mt-4 font-display text-xl font-bold text-white">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-400">
                                {s.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Process;
